"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _propTypes = require("prop-types");

var _react = _interopRequireWildcard(require("react"));

var _ProductReviews = _interopRequireDefault(require("../ProductReviews/ProductReviews.index"));

var _QuestionsAndAnswers = _interopRequireDefault(require("../QuestionsAndAnswers/QuestionsAndAnswers.index"));

var _BazaarVoice = require("./BazaarVoice.api");

var _BazaarVoice2 = _interopRequireDefault(require("./BazaarVoice.context"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var BazaarVoiceProvider = function BazaarVoiceProvider(_ref) {
  var bvApiUrl = _ref.bvApiUrl,
      bvConversationsApiUrl = _ref.bvConversationsApiUrl,
      bvPasskey = _ref.bvPasskey,
      children = _ref.children,
      isLazy = _ref.isLazy,
      productId = _ref.productId;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isBVAvailable = _useState2[0],
      setIsBVAvailable = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      ratingsData = _useState4[0],
      setRatingsData = _useState4[1];

  (0, _react.useEffect)(function () {
    var isSubscribed = true;

    if (window.$BV) {
      return setIsBVAvailable(true);
    }

    (0, _BazaarVoice.getBVApi)(bvConversationsApiUrl, productId).then( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var ratings;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isSubscribed) {
                _context.next = 7;
                break;
              }

              setIsBVAvailable(true);

              if (!(bvApiUrl && bvPasskey)) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return (0, _BazaarVoice.getBVRatings)({
                bvApiUrl: bvApiUrl,
                bvPasskey: bvPasskey,
                productId: productId
              });

            case 5:
              ratings = _context.sent;
              setRatingsData(ratings);

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    return function () {
      isSubscribed = false;
    };
  }, [bvApiUrl, bvConversationsApiUrl, bvPasskey, isLazy, productId]);
  return /*#__PURE__*/_react["default"].createElement(_BazaarVoice2["default"].Provider, {
    value: {
      getBVApi: _BazaarVoice.getBVApi,
      isBVAvailable: isBVAvailable,
      ratingsData: ratingsData,
      test: 'MY TEXT',
      productId: productId
    }
  }, children);
};

BazaarVoiceProvider.Context = _BazaarVoice2["default"];
var ProductReviewType = (0, _propTypes.shape)({
  type: _ProductReviews["default"]
});
var QuestionsAndAnswerType = (0, _propTypes.shape)({
  type: _QuestionsAndAnswers["default"]
});
BazaarVoiceProvider.propTypes = {
  /** URL to the Bazaar Voice API. */
  bvApiUrl: _propTypes.string,

  /** URL to the Bazaar Voice Conversations API. */
  bvConversationsApiUrl: _propTypes.string.isRequired,

  /** Bazaar Voice Passkey. */
  bvPasskey: _propTypes.string,

  /** Children. */
  children: (0, _propTypes.oneOfType)([_propTypes.node, ProductReviewType, QuestionsAndAnswerType]).isRequired,

  /** Defines if the Bazaar Voice API should be initialized only when an instance of ProductReviews or QuestionsAndAnswers enters the viewport. */
  isLazy: _propTypes.bool,

  /** ID of the product */
  productId: _propTypes.number.isRequired
};
BazaarVoiceProvider.defaultProps = {
  bvApiUrl: undefined,
  bvPasskey: undefined,
  isLazy: false
};
BazaarVoiceProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "BazaarVoiceProvider",
  "props": {
    "bvApiUrl": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "URL to the Bazaar Voice API.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "bvPasskey": {
      "defaultValue": {
        "value": "undefined",
        "computed": true
      },
      "description": "Bazaar Voice Passkey.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "isLazy": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Defines if the Bazaar Voice API should be initialized only when an instance of ProductReviews or QuestionsAndAnswers enters the viewport.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "bvConversationsApiUrl": {
      "description": "URL to the Bazaar Voice Conversations API.",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "children": {
      "description": "Children.",
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "custom",
          "raw": "ProductReviewType"
        }, {
          "name": "custom",
          "raw": "QuestionsAndAnswerType"
        }]
      },
      "required": true
    },
    "productId": {
      "description": "ID of the product",
      "type": {
        "name": "number"
      },
      "required": true
    }
  }
};
var _default = BazaarVoiceProvider;
exports["default"] = _default;